import { Component, OnInit } from '@angular/core';
import { GlobalService } from 'src/app/global.service';
import { HttpService } from 'src/app/http.service';

@Component({
  selector: 'app-validate-route-value-mismatch',
  templateUrl: './validate-route-value-mismatch.component.html',
  styleUrls: ['./validate-route-value-mismatch.component.scss']
})
export class ValidateRouteValueMismatchComponent implements OnInit {

  route_id = null;
  selected_date = null;
  session_id = null;
  title: any;
  mor_route_list: any;
  eve_route_list: any;
  mismatch_data: any =  null;

  constructor(private httpService: HttpService, private global: GlobalService, ) {
    this.title = this.global._active_display_name;
    this.httpService.serveDataForGeneralReport().subscribe((data: any) => {
      console.log(data);
      this.mor_route_list = data['mor_route_data'];
      this.eve_route_list = data['eve_route_data'];
    }, (error) => {
      console.log(error);
    });
  }

  getClicked() {
    let data_dict = {
      'date': this.selected_date,
      'route_id': this.route_id
    }
    this.mismatch_data = null;
    this.httpService.validateAndServeDataForMismatch(data_dict).subscribe((data) => {
      console.log(data)
      if (data['is_data_available']) {
        this.mismatch_data = data['mismatch_data'];
      } else {
        alert('There is no data available !!');
        return false;
      }
    }, (error) => {
      console.error(error);
    });
  }

  ngOnInit() {
  }

}
